// extracted by mini-css-extract-plugin
export var BookCard = "index-module--BookCard--7DLW5";
export var BookThumb = "index-module--BookThumb--F7DKf";
export var ClientContainer = "index-module--ClientContainer--AtUsH";
export var ClientWrap = "index-module--ClientWrap--bmmU7";
export var IptvBanner = "index-module--IptvBanner--ixbDd";
export var IptvState = "index-module--IptvState--aPKdW";
export var MaterialBookWrap = "index-module--MaterialBookWrap--dx-S0";
export var MaterialContainer = "index-module--MaterialContainer--Rdu8c";
export var MaterialContainerMobile = "index-module--MaterialContainerMobile--nY1fA";
export var MaterialSwiper = "index-module--MaterialSwiper--pZo9F";
export var MediaSwiper = "index-module--MediaSwiper--pY0KC";
export var NavMenu = "index-module--NavMenu--Q60Dx";
export var SchemeContainer = "index-module--SchemeContainer--COgsK";
export var SchemeWrap = "index-module--SchemeWrap--9CKNZ";
export var SchemeWrapMobile = "index-module--SchemeWrapMobile--bmypZ";
export var SolutionsSwiper = "index-module--SolutionsSwiper--BgUhe";
export var SolutionsSwiperButton = "index-module--SolutionsSwiperButton--iKjO0";
export var SolutionsSwiperMobile = "index-module--SolutionsSwiperMobile--r+W0p";
export var StructureButtonWrap = "index-module--StructureButtonWrap--+WQuJ";
export var StructureContainer = "index-module--StructureContainer--athaG";
export var StructureImage = "index-module--StructureImage--6rIeh";
export var active = "index-module--active--Jv68H";